import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { CButton, CForm, CFormInput, CFormLabel, CFormTextarea } from "@coreui/react-pro";

import VisibilitySensor from "react-visibility-sensor";
import { sendAnonymousReport } from "../../../services/sendAnonymousReport";
import { useAlert } from "../../../contexts/AlertContext";

function ReportsOne() {
  const { t } = useTranslation();

  const defaultFormData = {
    type: "",
    local: "",
    description: "",

    isResponseLoading: false
  }


  const [formData, setFormData] = useState(defaultFormData)

  const {showAlert} = useAlert()

  const handleSendReport = async () => {


    setFormData(prev => ({ ...prev, isResponseLoading: true }))

    const res = await sendAnonymousReport(formData)

    if (res.success) {
      setFormData(defaultFormData)
    }

    setFormData(prev => ({ ...prev, isResponseLoading: false }))

    showAlert(res.message, res.success ? 'success': 'error')

  }


  return (
    <VisibilitySensor partialVisibility minTopValue={100}>
      <div className="reportsOne">
        <div className="reportsText">
          <h1>{t("reports_title")} <span>{t("reports_title_span")}</span></h1>
          <p className="subTitle">{t("reports_subtitle")}</p>
          <div className="list">
            <p>{t("reports_details")}</p>
            <ul>
              <li>{t("reports_item1")}</li>
              <li>{t("reports_item2")}</li>
              <li>{t("reports_item3")}</li>
              <li>{t("reports_item4")}</li>
              <li>{t("reports_item5")}</li>
              <li>{t("reports_item6")}</li>
            </ul>
          </div>
        </div>
        <CForm id="anonimoForm">
          <div>
            <CFormLabel>{t("reports_type")}</CFormLabel>
            <CFormInput
              type="text"
              value={formData.type}
              maxLength={80}
              minLength={3}
              onChange={(event) => setFormData(prev => ({ ...prev, type: event.target.value }))}
              className="me-2"
              placeholder=""
            ></CFormInput>
            <CFormLabel>{t("reports_local")}</CFormLabel>
            <CFormInput
              type="text"
              value={formData.local}
              autoComplete='off'
              maxLength={40}
              onChange={(event) => setFormData(prev => ({ ...prev, local: event.target.value }))}
              className="me-2"
              placeholder=""
            ></CFormInput>
            <CFormLabel className="mt-2">{t("reports_description")}</CFormLabel>
            <CFormTextarea
              type="text"
              value={formData.description}
              autoComplete='off'
              maxLength={300}
              minLength={25}
              rows={4}
              as="text-area"
              onChange={(event) => setFormData(prev => ({ ...prev, description: event.target.value }))}
              className="me-2 message"
              placeholder=""
            ></CFormTextarea>
            <CButton className="mt-4" onClick={handleSendReport} disabled={formData.isResponseLoading}>
              {formData.isResponseLoading ? t("reports_sending") : t("reports_send")}
            </CButton>
          </div>
        </CForm>
      </div>
    </VisibilitySensor>
  );
}

export default ReportsOne;
